import React, { useState } from 'react';
import { toggleReportFavorite } from '../../../services/history.service';
import DownloadButton from './DownloadButton';
import { getConfidenceStats } from '../../../utils/formatters';

const ReportHeader = ({ reportData, onNewReport }) => {
  const [isFavorite, setIsFavorite] = useState(reportData.is_favorite || false);
  const confidenceStats = getConfidenceStats(reportData.confidence_levels);

  const handleToggleFavorite = async () => {
    if (!reportData._id) {
      console.warn('Cannot toggle favorite: Report ID is missing');
      return;
    }
    
    try {
      const data = await toggleReportFavorite(reportData._id, !isFavorite);
      
      if (data.success) {
        setIsFavorite(!isFavorite);
      }
    } catch (error) {
      console.error('Error toggling favorite:', error);
    }
  };

  return (
    <div className="report-header">
      <div className="report-title-section">
        <h1>{reportData.title}</h1>
        <p className="report-subtitle">Comprehensive Analysis Report</p>
        <p className="report-meta">
          Generated on: {reportData.generated_at} | Mode:{' '}
          {reportData.mode === 'advanced' ? 'Advanced' : 'Standard'} |
          Backend: {reportData.backend_type === 'strands' ? '🤖 Multi-Agent' : 
                    reportData.backend_type === 'mcp' ? '🔌 MCP' : '⚡ Traditional'} |
          Sections: {reportData.total_sections} |
          Research References: {reportData.research_papers_count || 0}
        </p>

        {confidenceStats && (
          <div className="confidence-stats">
            <h4>📊 Analysis Confidence Assessment</h4>
            <div className="confidence-table">
              <table className="confidence-assessment-table">
                <thead>
                  <tr>
                    <th>Confidence Level</th>
                    <th>Count</th>
                    <th>Percentage</th>
                    <th>Distribution</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="confidence-high">🟢 High Confidence</td>
                    <td>{confidenceStats.high.count}</td>
                    <td>{confidenceStats.high.percentage}%</td>
                    <td>
                      <div className="confidence-bar-bg">
                        <div
                          className="confidence-bar-fill high"
                          style={{ width: `${confidenceStats.high.percentage}%` }}
                        ></div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="confidence-medium">🟡 Medium Confidence</td>
                    <td>{confidenceStats.medium.count}</td>
                    <td>{confidenceStats.medium.percentage}%</td>
                    <td>
                      <div className="confidence-bar-bg">
                        <div
                          className="confidence-bar-fill medium"
                          style={{ width: `${confidenceStats.medium.percentage}%` }}
                        ></div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="confidence-low">🔴 Low Confidence</td>
                    <td>{confidenceStats.low.count}</td>
                    <td>{confidenceStats.low.percentage}%</td>
                    <td>
                      <div className="confidence-bar-bg">
                        <div
                          className="confidence-bar-fill low"
                          style={{ width: `${confidenceStats.low.percentage}%` }}
                        ></div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="confidence-summary">
              <p>
                <strong>Overall Reliability:</strong> {confidenceStats.overall}
              </p>
            </div>
          </div>
        )}
      </div>

      <div className="report-actions">
        {reportData._id && (
          <button 
            onClick={handleToggleFavorite}
            className={`favorite-btn-large ${isFavorite ? 'active' : ''}`}
            title={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
          >
            {isFavorite ? '⭐ Favorited' : '☆ Add to Favorites'}
          </button>
        )}
        <DownloadButton reportData={reportData} />
        <button onClick={onNewReport} className="new-report-btn">
          ✨ New Report
        </button>
      </div>
    </div>
  );
};

export default ReportHeader;
